/** @jsx jsx */
import { Box, Flex, Stepper } from "@eworkit/iris";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { useWizard } from "./useWizard";

interface WizardStepsProps {}

export const WizardSteps: FC<WizardStepsProps> = ({}) => {
  const { t } = useTranslation("common");

  const breakpoint = useBreakpointIndex();

  const { steps, currentStep, currentStepIndex, goToPrevStep } = useWizard();

  return (
    <Flex
      flexDirection="column"
      p={[null, null, null, "sm"]}
      borderBottom={[null, null, null, "primary"]}
      justifyContent="center"
      sx={{
        position: "sticky",
        top: [93, null, null, 75],
        backgroundColor: "n0",
        zIndex: 2,
      }}>
      <Stepper
        sx={{
          justifyContent: "center",
        }}
        aria-label={t("COMPONENTS.WIZARD.STEPS")}
        steps={steps.map((s, i) => ({
          order: i + 1,
          title: s.label,
          state: currentStep === s.step ? "CURRENT" : s.step < currentStep ? "DONE" : "FUTURE",
        }))}
        progressLabel={(currentStep, stepsCount) =>
          t("COMPONENTS.WIZARD.STEP", { step: currentStep, steps: stepsCount })
        }
        view={breakpoint > 2 ? "desktop" : "mobile"}
        onBackButtonClick={currentStepIndex > 0 ? goToPrevStep : undefined}
      />
      <Box
        sx={{
          height: 4,
          width: "100%",
          backgroundColor: "n0",
        }}
      />
    </Flex>
  );
};
